import { createUseStyles } from 'react-jss';

import { Transition } from '../../../styles';

const useStyles = createUseStyles(
  {
    root: {
      overflow: 'hidden',
    },
    container: {
      cursor: 'grab',
      display: 'grid',
    },
    page: {
      display: 'flex',
      flexDirection: 'column',
    },
    image: {
      cursor: 'initial',
      display: 'block',
      marginInline: 'auto',
      maxWidth: '100%',
      marginBottom: 24,
    },
    content: {
      height: '100%',
    },
    indicatorBack: {
      height: 2,
      marginTop: 24,
      marginInline: 24,
      width: 'calc(100% - 48px)',
    },
    indicatorFront: {
      background: 'var(--x-accent-1-1)',
      height: '100%',
      transition: `all ${Transition.Default} ease-in-out`,
    },
  },
  { name: 'ImageCarousel' },
);

export default useStyles;
